import { request } from '@/utils/request'

export default {
  systemSettings () {
    return request({
      url: 'settings'
    })
  }
}
